import { useState } from "react";
import Utils from "../../middleware/Utils";
import Select from "react-select";
import { globalSelectStyles } from "../../middleware/enum";

const Profile = ({ isOpen, onClose }) => {
    const [formData, setFormData] = useState({
        firstName: "Ajay",
        lastName: "Aher",
        RoleTypeID: 1,
        email: "jobmongo@gmail.com",
        phoneCodeID: 3,
        phoneNumber: "5566998877",
        password: "Jobmongo",
        status: "",
    });

    // Handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // Handle role selection change
    const handleRoleChange = (selectedOption) => {
        setFormData((prev) => ({ ...prev, RoleTypeID: selectedOption?.value }));
    };

    // Handle phone code selection change
    const handlePhoneCodeChange = (selectedOption) => {
        setFormData((prev) => ({ ...prev, phoneCodeID: selectedOption?.value }));
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-3xl">

                {/* Header */}
                <div className="bg-[#ECF6FF] px-6 py-4 border-b flex justify-between items-center">
                    <h2 className="text-16  font-semibold">Profile</h2>
                    <button className="text-gray-500 hover:text-gray-700" onClick={onClose}>✕</button>
                </div>

                {/* Body */}
                <div className="p-6 grid grid-cols-2 gap-4">

                    {/* First Name */}
                    <div>
                        <label className="block text-gray-700 text-12 mb-1">First Name</label>
                        <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} className="w-full p-2 border rounded-md text-12 bg-gray-100" placeholder="Enter First Name" />
                    </div>

                    {/* Last Name */}
                    <div>
                        <label className="block text-gray-700 text-12 mb-1">Last Name</label>
                        <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} className="w-full p-2 border rounded-md text-12 bg-gray-100" placeholder="Enter Last Name" />
                    </div>



                    {/* Email */}
                    <div>
                        <label className="block text-gray-700 text-12 mb-1">Email</label>
                        <input type="email" name="email" readOnly disabled value={formData.email} onChange={handleChange} className="w-full p-2 border rounded-md text-12 bg-gray-100" placeholder="Enter Email" />
                    </div>

                    {/* Phone */}
                    <div>
                        <label className="block text-gray-700 text-12 mb-1">Phone</label>
                        <div className="flex items-center border border-gray-300 rounded-md">
                            <Select
                                className="w-24 sm:w-32"
                                isDisabled
                                options={Utils.countryOptions}
                                onChange={handlePhoneCodeChange}
                                value={Utils.countryOptions.find(option => option.value === formData.phoneCodeID)}
                                styles={globalSelectStyles}
                            />
                            <input
                                type="number"
                                name="phoneNumber"
                                readOnly
                                disabled
                                value={formData.phoneNumber}
                                onChange={handleChange}
                                className="flex-grow p-2 border-l border-gray-300 focus:outline-none w-full"
                                placeholder="Enter phone number"
                            />
                        </div>
                    </div>

                    {/* Password */}
                    <div>
                        <label className="block text-gray-700 text-12 mb-1">Password</label>
                        <input type="password" name="password" value={formData.password} onChange={handleChange} className="w-full p-2 border rounded-md text-12 bg-gray-100" placeholder="Enter Password" />
                    </div>


                </div>

                {/* Footer */}
                <div className="bg-gray-100 px-6 py-4 border-t flex justify-end gap-3">
                    <button className="mx-2 px-4 py-2 bg-gray-300 rounded-md text-12" onClick={onClose}>Cancel</button>
                    <button className="px-4 py-2 text-white bg-[#E86B1B] rounded-md text-12" onClick={() => console.log(formData)}>Submit</button>
                </div>
            </div>
        </div>
    );
};

export default Profile;
